import styled from 'styled-components';

const SkillListContainer = styled.div`
  flex-basis: 80%;
`;

export default SkillListContainer;
